import { NgModule } from '@angular/core';
import { RouterModule, CanActivate } from '@angular/router';

import { SharedModule } from '../../../core/modules/shared.module';

import { FuseSampleComponent } from './sample.component';
import { RoleGuardService as RoleGuard } from './../Seguridad/role-guard.service';

const routes = [
    {
        path     : 'dashboard',
        component: FuseSampleComponent,
        canActivate: [RoleGuard], 
        data: { 
          formulario: 'dashboard'
        } 
    }
];

@NgModule({
    declarations: [
        FuseSampleComponent
    ],
    imports     : [
        SharedModule,
        RouterModule.forChild(routes)
    ],
    exports     : [
        FuseSampleComponent
    ]
})

export class FuseSampleModule
{
}



// WEBPACK FOOTER //
// D:/Repositorios/FacturacionWeb/src/app/main/content/sample/sample.module.ts